import { render, staticRenderFns } from "./UserSettingsContactList.vue?vue&type=template&id=f8873c9c&"
import script from "./UserSettingsContactList.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8873c9c')) {
      api.createRecord('f8873c9c', component.options)
    } else {
      api.reload('f8873c9c', component.options)
    }
    module.hot.accept("./UserSettingsContactList.vue?vue&type=template&id=f8873c9c&", function () {
      api.rerender('f8873c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsContact/UserSettingsContactList.vue"
export default component.exports